var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOrixLogoGray(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 55.943,
    height: 56,
    viewBox: "0 0 55.943 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_1631",
    "data-name": "\\u9577\\u65B9\\u5F62 1631",
    width: 55.627,
    height: 56,
    transform: "translate(-0.33)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_2074",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 2074",
    transform: "translate(0.33)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_1630",
    "data-name": "\\u9577\\u65B9\\u5F62 1630",
    width: 55.613,
    height: 56,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_2040",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 2040"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_2039",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 2039",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_2074-2",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 2074",
    transform: "translate(0.628 0.724)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_1190",
    "data-name": "\\u30D1\\u30B9 1190",
    d: "M113.745,123.541a2.286,2.286,0,0,1-.541-.63l-3.571-5.221,3.191-4.368a2.677,2.677,0,0,1,.58-.672h-1.8a.661.661,0,0,1-.164.676l-2.5,3.348-2.3-3.365a.684.684,0,0,1-.141-.659h-2.138a1.9,1.9,0,0,1,.62.689l3.093,4.48-3.68,4.942a2.851,2.851,0,0,1-.708.781h2.073a.6.6,0,0,1,.115-.666l2.916-4.021,2.748,3.981c.249.361.223.521.154.705Z",
    transform: "translate(-69.789 -75.781)",
    fill: "#878787"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_1191",
    "data-name": "\\u30D1\\u30B9 1191",
    d: "M69.721,117.245a4.722,4.722,0,0,1-.571-.033V113.5a2.687,2.687,0,0,1,.912-.115c1.577,0,2.41.879,2.41,1.823,0,1.072-.974,2.037-2.752,2.037m5.188,5.4-3.112-4a3.812,3.812,0,0,0-.781-.83v-.039a2.717,2.717,0,0,0,2.863-2.6c0-1.469-1.036-2.5-3.384-2.5H67.58c.18.22.187.259.187,1.066v8.933a1.253,1.253,0,0,1-.2.889h1.781c-.2-.279-.2-.341-.2-.889v-5.359c.193.085.374.377.813.931,1.213,1.525,3.493,4.877,3.945,5.313h1.9v-.016a3.154,3.154,0,0,1-.9-.9",
    transform: "translate(-45.522 -75.795)",
    fill: "#878787"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_1192",
    "data-name": "\\u30D1\\u30B9 1192",
    d: "M97.291,123.548a1.253,1.253,0,0,1-.2-.889v-8.933c0-.807,0-.846.187-1.066H95.53c.18.22.187.259.187,1.066v8.933a1.253,1.253,0,0,1-.2.889Z",
    transform: "translate(-64.306 -75.787)",
    fill: "#878787"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_1193",
    "data-name": "\\u30D1\\u30B9 1193",
    d: "M36.479,122.565c-2.44,0-4.073-2.25-4.073-4.683s1.614-4.683,4.073-4.683c2.374,0,4.034,2.246,4.034,4.683,0,2.414-1.659,4.683-4.034,4.683m0-10.235A5.549,5.549,0,1,0,42,117.879a5.464,5.464,0,0,0-5.519-5.549",
    transform: "translate(-20.918 -75.565)",
    fill: "#878787"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_1194",
    "data-name": "\\u30D1\\u30B9 1194",
    d: "M30.97,30.357v1.115l33.91-9.74V20.62Z",
    transform: "translate(-20.925 -13.932)",
    fill: "#878787"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_1195",
    "data-name": "\\u30D1\\u30B9 1195",
    d: "M50.841,34.725a2.383,2.383,0,0,1-2.479-1.673L30.97,38.047v1.112l16.722-4.8a3.837,3.837,0,0,0,3.345,1.528c2.027,0,4.595-1.643,4.641-3.821l9.206-2.643V28.31l-10.39,2.984c.367,2.2-1.876,3.43-3.653,3.43",
    transform: "translate(-20.925 -19.099)",
    fill: "#878787"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_1196",
    "data-name": "\\u30D1\\u30B9 1196",
    d: "M50.932,43.175c-1.974,0-3.778-.843-4.388-1.932L30.96,45.72v1.112l15.411-4.424c.436.833,2.3,1.905,4.723,1.905,3.624,0,7.048-2.958,7.32-5.365l6.461-1.856V35.98l-7.3,2.1c.1,2.23-3.014,5.1-6.638,5.1",
    transform: "translate(-20.918 -24.255)",
    fill: "#878787"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_1197",
    "data-name": "\\u30D1\\u30B9 1197",
    d: "M51.356,51.2a6.367,6.367,0,0,1-5.234-2.145L30.97,53.407v1.115l15.253-4.381a6.9,6.9,0,0,0,5.132,2.05c4.614,0,8.015-3.152,8.517-5.969l5.011-1.44V43.67l-5.428,1.558c-.64,3.276-4.188,5.972-8.1,5.972",
    transform: "translate(-20.925 -29.423)",
    fill: "#878787"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_1198",
    "data-name": "\\u30D1\\u30B9 1198",
    d: "M51.962,58.765A6.507,6.507,0,0,1,46.6,56.584L30.97,61.074v1.112l16.044-4.608a6.941,6.941,0,0,0,5.188,2.04,8.384,8.384,0,0,0,8.264-5.9l4.418-1.269V51.33L60.3,52.648c-.951,4.273-5.05,6.116-8.34,6.116",
    transform: "translate(-20.925 -34.571)",
    fill: "#878787"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_1199",
    "data-name": "\\u30D1\\u30B9 1199",
    d: "M47.84,73.94,30.96,78.787V79.9L48.6,74.835a3.558,3.558,0,0,1-.761-.9",
    transform: "translate(-20.918 -49.766)",
    fill: "#878787"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_1200",
    "data-name": "\\u30D1\\u30B9 1200",
    d: "M119.85,61.509l4.762-1.368V59.03l-4.493,1.289a7.486,7.486,0,0,1-.269,1.19",
    transform: "translate(-80.657 -39.746)",
    fill: "#878787"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_1201",
    "data-name": "\\u30D1\\u30B9 1201",
    d: "M30.97,85.242l33.91-9.737V74.39L30.97,84.13Z",
    transform: "translate(-20.925 -50.068)",
    fill: "#878787"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_1202",
    "data-name": "\\u30D1\\u30B9 1202",
    d: "M60,67.245c.023-.075-.049-.118-.1-.033A8.606,8.606,0,0,1,52.3,71.029a7.038,7.038,0,0,1-3.02-.653c-.069-.033-.128.013-.056.066a6.056,6.056,0,0,0,.843.518L30.96,76.447v1.115L51.788,71.58a6.7,6.7,0,0,0,1.446.167,7.1,7.1,0,0,0,5.028-2.027l6.612-1.9V66.71l-5.408,1.551A5.221,5.221,0,0,0,60,67.245",
    transform: "translate(-20.918 -44.906)",
    fill: "#878787"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrixLogoGray);
export default __webpack_public_path__ + "static/media/orix_logo_gray.7e5d99fbbf972241e16d969bd2eda3cb.svg";
export { ForwardRef as ReactComponent };